import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { tasks } from "lobbie";

export interface ITaskDashboardState {
    show: boolean;
    updateTaskCount?: () => void;
    activeTask?: tasks.ITask;
}

export const initialStateTaskDashboard: ITaskDashboardState = {
    show: false,
    activeTask: undefined,
    updateTaskCount: undefined,
};

const taskDashboardSlice = createSlice({
    name: "taskDashboardSlice",
    initialState: initialStateTaskDashboard,
    reducers: {
        showTaskDashboardDrawer: (
            _state,
            action: PayloadAction<Omit<ITaskDashboardState, "show" | "activeTask">>,
        ) => {
            return {
                ...action.payload,
                // Keep active task when reopening drawer
                activeTask: _state.activeTask,
                show: true,
            };
        },
        hideTaskDashboardDrawer: (state) => {
            return {
                ...state,
                show: false,
            };
        },
        makeTaskActive: (
            state,
            action: PayloadAction<Omit<ITaskDashboardState, "show" | "onCloseDrawer">>,
        ) => {
            state.activeTask = action.payload.activeTask;
        },
    },
});

export const { showTaskDashboardDrawer, hideTaskDashboardDrawer, makeTaskActive } =
    taskDashboardSlice.actions;
export default taskDashboardSlice.reducer;
